import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function NormalMarginsIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 39, width: 32 }}
      viewBox="0 0 32 39"
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#FFF" height="38" rx="3" stroke={IconColors.Grey} width="31" x=".5" y=".5" />
        <path d="M5.5 1.001V38M31 33.5H1M31 5.5H1" stroke="#146EE8" />
        <path d="M26.5 1.001V38" opacity=".994" stroke="#146EE8" />
      </g>
    </SvgIcon>
  );
}
